<template>
  <div v-if="serviceLevelIsSupported" class="form-group">
    <div class="label required fs-xl">Choose Service Level</div>
    <div class="row">
      <div class="col-12 col-md-6">
        <input id="service_level_priority" v-model="level" type="radio" value="priority" />
        <label for="service_level_priority" class="radio-group">
          <span class="radio-title">Priority</span>
        </label>
      </div>
      <div class="col-12 col-md-6">
        <input id="service_level_economy" v-model="level" type="radio" value="economy" />
        <label for="service_level_economy" class="radio-group">
          <span class="radio-title">Economy</span>
          <span v-if="showDeliveryTime" class="radio-description"> 1-4 days </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { AssignmentCreationData } from '@/types/Models/Assignment'
import { ref, computed, defineComponent, watch, type ComputedRef, type Ref } from 'vue'
import { PRIORITY } from '@/const/AssignmentServiceLevels'
import { BOX, LETTER, PARCEL } from '@/const/DistributionChannels'
import { useAssignmentFormStore } from '@/store/assignmentForm'

export default defineComponent({
  name: 'ServiceLevel',
  setup() {
    const assignmentFormStore = useAssignmentFormStore()

    const assignment: ComputedRef<AssignmentCreationData> = computed(() => assignmentFormStore.assignment)
    const serviceLevelIsSupported: ComputedRef<boolean> = computed(
      () => ![PARCEL, LETTER, BOX].includes(assignment.value.distribution_channel),
    )
    const showDeliveryTime: ComputedRef<boolean> = computed(() => assignment.value.item.country_code === 'SE')

    const level: Ref<string> = ref(PRIORITY)

    watch(level, (value) => assignmentFormStore.setFields({ service_level: value }))

    watch(
      assignment,
      (value) => {
        if (value.service_level !== level.value) {
          level.value = value.service_level
        }
      },
      { deep: true },
    )

    return {
      showDeliveryTime,
      serviceLevelIsSupported,
      level,
    }
  },
})
</script>
